
import useBookingState, {B_ACTIONS}             from '../Booking/bookingReducer'
/* 
 * React component to overlay the team calendar to select to apply rota time to
 * a person's diary.
 */

import React, {useState, useEffect}     from 'react'

import {TwoTimeEdit}                    from '../../lib/iprs-react-library/src/index.js'
import {OKCancel}                       from '../../lib/iprs-react-library/src/index.js'
import {isRotaTypeHidden}               from '../../hiddenRotaTypes'

const NCAOverlay = ({api, selectInfo, done, calendarApi, setError, state, eventDispatch}) => {
    
    //const { action, event: eventInfo } = selectInfo
    
    const {start, end, 
        extendedProps: {apiEvent: {
            RotaID: rotaID                  = 0,
            PartyID: ePartyID               = 0,
            RotaTypeID: defaultRotaTypeID   = 0,
            Description: evDescription      = '',
            Title: evTitle                  = '',
            Available: available            = false
        } = {} } = {},
        resource: { id: rPartyID} = {}
    }                                               = selectInfo
    /* comes from internal event or api depending whether we are creating a new 
     * rota entry */
    const partyID = rPartyID? rPartyID: ePartyID        
    
    /* state of form elements */
    const [rTypeList,  setRTypeList]                = useState([])
    const [rotaTypeID, setRotaTypeID]               = useState(defaultRotaTypeID)
    const [startTime, setStartTime]                 = useState(start);
    const [endTime,   setEndTime]                   = useState(end);
    const [busy,        setBusy]                    = useState(!available);
    
    const [title, setTitle]                         = useState(evTitle);
    const [description, setDescription]             = useState(evDescription);
    /* If the title has been edited or this is an existing item we won't set
     * the title from the type dropdown. */
    const [titleTouched,setTitleTouched]            = useState(0!==rotaID);
    
    
    /* The available appTypes for this time and person */
    const [availableAppTypes, setAvailableAppTypes] = useState([]);

    /* The current team's group, if any, used to filter the Task Type list
     * below down to the RotaTypes relevant to this team (see
     * TeamGroupRotaTypeOperation.GetEffectiveRotaTypeList on the backend). */
    const groupID = state?.team?.teamGroupLookup?.[state?.team?.teamID]?.GroupID;

    const handleTitleChange = e => {
        
        e.preventDefault();
        const newTitle = e.target.value;
        /* We reset the title as untouched if it's empty. Otherwise once edited
         * it won't be repopulated from the type drop down */
        if( newTitle.trim().length ){
            setTitleTouched(true);
        }else{
            setTitleTouched(false);
        }
        setTitle( e.target.value );
    }
    
    useEffect( () => {
        /* When the current team belongs to a group, use the group-filtered
         * RotaType list (excludes any RotaType a Diary Manager has hidden
         * for that group - see Settings). Otherwise fall back to the full,
         * unfiltered list as before. */
        const rotaTypeListPromise = groupID
            ? api.transact('RotaTypeListByGroup', { groupID }).then( r => r.apiResult.RotaTypes )
            : api.getRotaTypeList().then( response => response.apiResult )

        rotaTypeListPromise
            .then( r => r.filter( rt => 1 !== rt.RotaTypeID && !isRotaTypeHidden( rt.RotaTypeID ) ) )
            .then( r        => {
                setRTypeList(r)
                if(!defaultRotaTypeID){
                    setRotaTypeID( r[0].RotaTypeID );
                    setTitle(r[0].Description);
                }
            })
            .catch( e => setError(e.message) )
    } , [api, defaultRotaTypeID, setError, groupID] )
    
    
    const saveRota = e => {

        e.preventDefault()
        
        setError( '' )
    
        let createSave
        if (rotaID){
            createSave = api.updateTask(rotaID,     startTime, 
                                                    endTime,
                                                    description,
                                                    partyID,
                                                    rotaTypeID,
                                                    !busy,
                                                    title)
        }else{
            createSave = api.createTask(partyID,    startTime, 
                                                    endTime, 
                                                    description,
                                                    rotaTypeID,
                                                    !busy,
                                                    title)
        }
        
        createSave.then ( response => response.apiResult )
        .then( apiResult => {

            /* hack to get REACT to re-render*/
            //doRerender( rerender+1 )
            if(calendarApi.unselect){
                calendarApi.unselect() // clear date selection
            }

            done()
        })
        .catch(e => {
            console.log(e)
            if(calendarApi.unselect){
                calendarApi.unselect() // clear date selection
            }
            
            setError( e.apiText )
        })
    }
     
     const handleChange = e => {
        
        e.preventDefault()
        
        const newItem = Number.parseInt( e.target.value, 10 );
        setRotaTypeID( newItem );
        if( !titleTouched ){
            
            /* If the user hasn't entered a title then we fill it in with the 
             * contents of the drop down to save typing. Requested by Diane H.*/
            const newTitle = rTypeList.filter( r => r.RotaTypeID === newItem )[0].Description;
            setTitle( newTitle );
        }
    }
    
    const [,bookingUpdater]        = useBookingState(state, eventDispatch);
    
    const handleMakeBooking = e => {
        e.preventDefault()
        
        /* signal to the new time but no need for an overlay as we'll
         * switch to the booking screen. Unbundle everything into something
         * for the booking module to handle*/ 
        const { resource: { id: partyID, title: partyName = '' } = {}} = selectInfo
        const newEvent = { start: startTime, end: endTime, partyID, partyName, availableAppTypes }

        bookingUpdater( B_ACTIONS.PERSONAL_TIME, newEvent )
    }
    
    const handleDeleteRota = e => {
        
        e.preventDefault()
        
        api.deleteTask(rotaID)
        .then( response => {
            done()
        })
        .catch( err     => setError(err.message) )
    }
    
    useEffect( () => {
        /* we clicked on an area with no tasks or bookings. We need to check if there
         * is availablility here. We could cache all the diary data and search. The
         * calendar doesn't seem to provide the rota info, which is in the background
         * (visually), so eaiest to go to the backend to find available types for 
         * this user at this time. 
         * Note that this will update every time the start and end times are 
         * changed. */
        if(!rotaID){
            api.GetPartyTimeAppointmentTypeList( partyID, startTime, endTime )
                .then( r    => {
                    setAvailableAppTypes( r.apiResult );
                    setError(null)} )
                .catch( err => setError(err.message) ); 
        }
    }, [api, partyID, startTime, endTime, rotaID, setError]);
    
    return (<>
    
        <div className='wrapper' >
            {((!rotaID) && availableAppTypes.length ) ? <button onClick={handleMakeBooking} >Make Booking</button>: ''}
            {rotaID ?<button onClick={handleDeleteRota} >Delete Task</button>: ''}
        </div>
        <h2>{rotaID? 'Task': 'Create Task'}</h2>
        
        <label htmlFor='taskTitle' >Title</label>
        <input name='taskTitle' value={title} onChange={handleTitleChange} />
        
        <label htmlFor='desc' >Description</label>
        <textarea name='desc'  value={description} 
                    onChange={e => setDescription(e.target.value)} rows='5' cols='80' />
        <h2>Time</h2>
        <TwoTimeEdit start={startTime} end={endTime} onStartChange={setStartTime} 
            onEndChange={setEndTime} startLabel='Start Time' endLabel='End Time' />
            
        <h2>Task Type</h2>
        <select name='typeSelect' onChange={handleChange} value={rotaTypeID} >
            { rTypeList.sort( (a,b) => a.Description.localeCompare( b.Description ) )
              .map( t => (<option key={t.RotaTypeID} 
            value={t.RotaTypeID} >{t.Description}</option>) ) }
        </select>
         
        <label>Busy</label>
        <input name='busy' type='checkbox' onChange={e=>setBusy(e.target.checked)} checked={busy} />
        
        <p></p>
        <OKCancel onOK={saveRota} onCancel={done} />
    </>)
}

export default NCAOverlay 

